<template>
  <button @click="process_detail_dialog?.showModal()">Chi tiết</button>
  <teleport to="#app">
    <dialog ref="process_detail" class="modal">
      <div class="modal-box">
        <div class="mb-4 flex items-baseline justify-between">
          <h3 class="text-lg font-bold">
            Chi tiết tiến trình {{ process?.pid }}
          </h3>
          <form method="dialog" class="flex gap-2">
            <button class="btn btn-sm" value="cancel">&times;</button>
          </form>
        </div>

        <pre><code class="language-json"><span v-html="highlighted_code"></span></code></pre>

        <div class="modal-action"></div>
      </div>
    </dialog>
  </teleport>
</template>

<script setup lang="ts">
import hljs from "highlight.js/lib/core";
import json from "highlight.js/lib/languages/json";
import "highlight.js/styles/github.css";
import { ref } from "vue";
import type { process as ProcessType } from ".";

const process_detail_dialog = ref<HTMLDialogElement | null>();
const props = defineProps<{
  process?: ProcessType;
}>();

hljs.registerLanguage("json", json);
const highlighted_code = hljs.highlight(
  JSON.stringify(props.process, null, "\t"),
  {
    language: "json",
  },
).value;
</script>
